(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["3-community"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('scroll-image-banner')) {
    customElements.define('scroll-image-banner', class extends HTMLElement {
      connectedCallback() {
        this.events?.abort();
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.frame);
        this.frame = null;
        this.track = this.querySelector('.sib__track');
        if (!this.track) return;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        window.addEventListener('scroll', () => this.scheduleCheck(), { ...options, passive: true, capture: true });
        window.addEventListener('resize', () => this.scheduleCheck(), options);
        document.addEventListener('visibilitychange', () => this.scheduleCheck(), options);
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.scheduleCheck());
          this.resizeObserver.observe(this.track);
        }
        this.checkPosition();
      }
      scheduleCheck() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.checkPosition();
        });
      }
      checkPosition() {
        const rect = this.track.getBoundingClientRect();
        const viewport = document.documentElement;
        // Use clientWidth rather than 100vw so the scrollbar cannot cause overflow.
        this.style.setProperty('--sib-viewport-width', `${viewport.clientWidth}px`);
        this.style.setProperty('--sib-full-offset', `${-rect.left}px`);
        const visible = Math.max(0, Math.min(rect.bottom, viewport.clientHeight) - Math.max(rect.top, 0));
        const reachable = Math.min(rect.height, viewport.clientHeight);
        if (!this.contained && reachable > 0 && visible >= reachable * 0.5) {
          this.contained = true;
          this.classList.add('sib--contained');
        } else if (this.contained && visible < reachable * 0.45) {
          this.contained = false;
          this.classList.remove('sib--contained');
        }
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.frame = null;
        this.events?.abort();
        this.resizeObserver?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["3-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('video-text-banner')) {
    customElements.define('video-text-banner', class extends HTMLElement {
      connectedCallback() {
        this.events?.abort();
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.frame);
        this.shell = this.parentElement;
        this.video = this.querySelector('video');
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.video?.addEventListener('playing', () => {
          if (!this.activated || !this.inView || document.hidden) {
            this.video.pause();
            return;
          }
          this.classList.add('vt--video-ready');
        }, options);
        this.video?.addEventListener('error', () => {
          this.classList.remove('vt--video-ready');
        }, options);
        this.motion.addEventListener('change', () => {
          if (this.motion.matches) this.video?.pause();
          else this.autoPlay();
        }, options);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.video?.pause();
          else this.scheduleCheck();
        }, options);
        window.addEventListener('scroll', () => this.scheduleCheck(), { ...options, passive: true, capture: true });
        window.addEventListener('resize', () => this.scheduleCheck(), options);
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.scheduleCheck());
          this.resizeObserver.observe(this.shell);
        }
        this.scheduleCheck();
      }
      scheduleCheck() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.checkPosition();
        });
      }
      checkPosition() {
        // Measure the stable shell, so expanding the banner cannot change its trigger.
        const rect = this.shell.getBoundingClientRect();
        const viewportHeight = document.documentElement.clientHeight;
        this.style.setProperty('--vt-viewport-width', `${document.documentElement.clientWidth}px`);
        this.style.setProperty('--vt-full-offset', `${-rect.left}px`);
        const visibleHeight = Math.max(0, Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0));
        this.inView = visibleHeight > 0;
        // For banners taller than the screen, half of the screen is the reachable threshold.
        const triggerHeight = Math.min(rect.height, viewportHeight) * 0.5;
        if (!this.activated && triggerHeight > 0 && visibleHeight >= triggerHeight && !document.hidden) {
          this.activate();
        } else if (this.activated && visibleHeight < Math.min(rect.height, viewportHeight) * 0.45) {
          // A small gap between enter/exit thresholds avoids flicker near halfway.
          this.deactivate();
        }
        if (!this.inView) this.video?.pause();
        else this.autoPlay();
      }
      activate() {
        this.activated = true;
        this.classList.add('vt--active');
        this.classList.remove('vt--content-waiting');
        if (!this.video || this.sourcesLoaded) return;
        this.video.muted = true;
        this.video.querySelectorAll('source[data-src]').forEach(source => {
          source.src = source.dataset.src;
          source.removeAttribute('data-src');
        });
        this.video.preload = 'auto';
        this.video.load();
        this.sourcesLoaded = true;
      }
      deactivate() {
        this.activated = false;
        this.video?.pause();
        this.classList.remove('vt--active', 'vt--video-ready');
        this.classList.add('vt--content-waiting');
      }
      tryPlay() {
        if (!this.activated || !this.video || this.playPending) return;
        this.playPending = true;
        const attempt = this.video.play();
        // If autoplay is blocked, keep the poster visible without an unhandled rejection.
        if (attempt) attempt.catch(() => {}).finally(() => { this.playPending = false; });
        else this.playPending = false;
      }
      autoPlay() {
        if (this.activated && this.inView && this.video?.paused && !document.hidden && this.dataset.autoplay === 'true' && !this.motion.matches) {
          this.tryPlay();
        }
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.frame = null;
        this.resizeObserver?.disconnect();
        this.events?.abort();
        this.deactivate();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    

  class StickyHeader extends HTMLElement {

    constructor() {

      super();

      this.setHeaderHeight = this.setHeaderHeight.bind(this);

    }



    connectedCallback() {

      this.header = document.querySelector('.section-header');

      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');

      this.headerIsAlwaysSticky =

        this.getAttribute('data-sticky-type') === 'always' ||

        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.headerBounds = {};



      this.setHeaderHeight();



      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);



      if (this.headerIsAlwaysSticky) {

        this.header.classList.add('shopify-section-header-sticky');

      }



      this.currentScrollTop = 0;

      this.preventReveal = false;

      this.predictiveSearches = this.querySelectorAll('predictive-search');



      this.onScrollHandler = this.onScroll.bind(this);

      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);



      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      window.addEventListener('scroll', this.onScrollHandler, false);



      this.createObserver();

    }



    setHeaderHeight() {

      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);

    }



    disconnectedCallback() {

      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      window.removeEventListener('scroll', this.onScrollHandler);

    }



    createObserver() {

      let observer = new IntersectionObserver((entries, observer) => {

        this.headerBounds = entries[0].intersectionRect;

        observer.disconnect();

      });



      observer.observe(this.header);

    }



    onScroll() {

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;



      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;



      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {

        this.header.classList.add('scrolled-past-header');

        if (this.preventHide) return;

        requestAnimationFrame(this.hide.bind(this));

      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {

        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {

          requestAnimationFrame(this.reveal.bind(this));

        } else {

          window.clearTimeout(this.isScrolling);



          this.isScrolling = setTimeout(() => {

            this.preventReveal = false;

          }, 66);



          requestAnimationFrame(this.hide.bind(this));

        }

      } else if (scrollTop <= this.headerBounds.top) {

        this.header.classList.remove('scrolled-past-header');

        requestAnimationFrame(this.reset.bind(this));

      }



      this.currentScrollTop = scrollTop;

    }



    hide() {

      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');

      this.closeMenuDisclosure();

      this.closeSearchModal();

    }



    reveal() {

      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add('shopify-section-header-sticky', 'animate');

      this.header.classList.remove('shopify-section-header-hidden');

    }



    reset() {

      if (this.headerIsAlwaysSticky) return;

      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');

    }



    closeMenuDisclosure() {

      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');

      this.disclosures.forEach((disclosure) => disclosure.close());

    }



    closeSearchModal() {

      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');

      this.searchModals.forEach((searchModal) => searchModal.close(false));

    }

  }



  // The account `open` event is composed but does not bubble, so listen during capture.

  // Anchor the dialog to the bottom of the account button itself. The header group can be

  // much taller than the button's row (for example, a top-left logo pushes the menu to a

  // second row), so anchoring to the section bottom drops the dialog too low.

  document.addEventListener(

    'open',

    (event) => {

      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;



      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));

      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);

    },

    true

  );



  customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();
})();
